import { render, staticRenderFns } from "./ImsOfferingMergefactor.vue?vue&type=template&id=20f8bd2a&scoped=true&"
import script from "./ImsOfferingMergefactor.vue?vue&type=script&lang=js&"
export * from "./ImsOfferingMergefactor.vue?vue&type=script&lang=js&"
import style0 from "./ImsOfferingMergefactor.vue?vue&type=style&index=0&id=20f8bd2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f8bd2a",
  null
  
)

export default component.exports